<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    fill-rule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M2.59544 20H17.4046V9.22348H2.59544V20ZM4.25826 18.363H15.7417V10.8604H4.25826V18.363Z"
    ></path>
    <path
      d="M1.5 10.8607H18.5V5.7431H1.5V10.8602V10.8607ZM3.16281 9.22348H16.8374V7.3803H3.16281V9.22348Z"
    ></path>
    <path d="M9.16883 19.3844H10.8316V6.4817H9.16883V19.3844Z"></path>
    <path
      d="M6.80399 4.24958e-06C6.44204 -0.000627917 6.08351 0.0692765 5.74887 0.205726C5.41423 0.342175 5.11003 0.542497 4.85365 0.795254C4.59768 1.04674 4.39452 1.34585 4.25589 1.67535C4.11726 2.00484 4.04588 2.35821 4.04588 2.71511C4.04588 3.07201 4.11726 3.42538 4.25589 3.75488C4.39452 4.08437 4.59768 4.38348 4.85365 4.63497C5.93089 5.69522 10.3139 6.17072 10.3139 6.17072C10.3139 6.17072 9.83084 1.85527 8.75408 0.795254C8.4977 0.542497 8.1935 0.342175 7.85886 0.205726C7.52422 0.0692765 7.1657 -0.000627917 6.80375 4.24958e-06H6.80399ZM6.80375 1.63696C7.09198 1.63696 7.36297 1.746 7.56879 1.94368C7.79137 2.21675 8.0729 3.11155 8.30603 4.19409C7.20627 3.9644 6.29771 3.68707 6.02026 3.46805C5.81937 3.26535 5.70763 2.99229 5.70943 2.70842C5.71123 2.42455 5.8264 2.15289 6.02984 1.95269C6.13144 1.85228 6.25209 1.77273 6.38486 1.71858C6.51763 1.66444 6.6599 1.63678 6.80351 1.6372"
    ></path>
    <path
      d="M12.7091 0.877505C12.0834 0.876562 11.4829 1.12152 11.0396 1.5585C10.1172 2.46635 9.70386 6.161 9.70386 6.161C9.70386 6.161 13.4567 5.75377 14.3787 4.84617C14.5979 4.63085 14.7718 4.37475 14.8905 4.09263C15.0093 3.8105 15.0704 3.50793 15.0704 3.20234C15.0704 2.89674 15.0093 2.59417 14.8905 2.31205C14.7718 2.02992 14.5979 1.77382 14.3787 1.5585C13.9354 1.12152 13.3349 0.876562 12.7091 0.877505V0.877505ZM12.7091 2.5147C12.8172 2.5147 13.0249 2.54077 13.2027 2.71618C13.3299 2.84149 13.4031 3.01072 13.4068 3.18829C13.4105 3.36586 13.3445 3.53794 13.2226 3.66835C13.0079 3.81626 12.4432 3.99616 11.7369 4.15901C11.9022 3.4645 12.085 2.90865 12.2357 2.69651C12.3648 2.5792 12.5338 2.51429 12.7091 2.5147"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'GiftSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
